import React, { PureComponent } from 'react';

import { I18n } from 'components/translate';
import { formatBytes } from 'helpers/File';
import FileModal from 'modules/file/components/FileModal';
import PropTypes from 'prop-types';

export class FileUploadSizeModal extends PureComponent {
  static propTypes = {
    maxFileSize: PropTypes.number
  };

  render() {
    return (
      <FileModal {...this.props} title="files.upload_failed.title">
        <p>
          <I18n
            html
            label="files.upload_failed.size"
            data={{ size: formatBytes(this.props.maxFileSize) }}
          />
        </p>
      </FileModal>
    );
  }
}

export class FileUploadExtensionModal extends PureComponent {
  render() {
    return (
      <FileModal {...this.props} title="files.upload_failed.title">
        <p>
          <I18n label="files.upload_failed.extension" />
        </p>
      </FileModal>
    );
  }
}

export class FileUploadLimitModal extends PureComponent {
  static propTypes = {
    filesLimit: PropTypes.number
  };

  static defaultProps = {
    filesLimit: 1
  };

  render() {
    return (
      <FileModal {...this.props} title="files.media_limit.title">
        <p>
          <I18n
            label="files.media_limit.confirm"
            data={{ limit: this.props.filesLimit }}
          />
        </p>
        <p>
          <I18n label="general.are_u_sure" />
        </p>
      </FileModal>
    );
  }
}
